import { VerificationError } from './VerificationError';

/**
 * Fetch a resource and verify its SHA-256 hash against the expected value.
 * Note: the browser transparently decompresses brotli/gzip if the CDN negotiates
 * content-encoding, so sha256 runs on the decompressed bytes.
 */
export async function fetchAndVerify(
  url: string,
  expectedSha256: string,
  init?: RequestInit,
): Promise<ArrayBuffer> {
  const response = await fetch(url, init);
  if (!response.ok) {
    throw new Error(`Failed to fetch ${url}: ${response.status}`);
  }
  const buf = await response.arrayBuffer();
  const hashBuf = await crypto.subtle.digest('SHA-256', buf);
  const actual = btoa(String.fromCharCode(...new Uint8Array(hashBuf)));
  if (actual !== expectedSha256) {
    throw new VerificationError(`Integrity check failed for ${url}`);
  }
  return buf;
}
